export const LOCAL  = 'local';
export const PROD   = 'prod';
